
export const ClientPositionOptions = [
  "Finance",
  "Sustainability",
  "Maintenance",
  "Admin",
  "Director",
  "CEO",
  "Facilities",
  "Sectary",
  "Customer Success",
  "Procurement",
  "Health and Safety",
  "Tech",
  "Building manager",
  "Site manager",
  "Mechanical Plumber",
  "Installer",
  "Other",
]